import React, { Component } from 'react';
import { push, replace } from 'react-router-redux';
import { connect } from 'react-redux';
import { setRole } from 'reducers/auth';

import LoginService from 'services/LoginService';

class TokenLogin extends Component {
  async componentDidMount() {
    let search = new URLSearchParams(this.props.location.search);
    let token = search.get('token');
    let role = false;

    try {
      role = await LoginService.tokenLogin(token);
    } catch (e) {
      console.error(e.message, e);
    }

    if (!!role) {
      let url = LoginService.getLoginPath(role);
      if (!!url) {
        this.props.setRole(role);
        return this.props.replace(url);
      } else {
        console.log('Bad Token');
      }
    }
  }
  render() {
    return (
      <div />
    );
  }
}

export default connect(null, dispatch => ({
  replace: url => dispatch(replace(url)),
  setRole: role => dispatch(setRole(role))
}))(TokenLogin);



// WEBPACK FOOTER //
// ./src/views/LoginView/TokenLoginView.js